<template>
  <div>
    <!-- 保养登记 -->
    <enrollment :title="$t('maintenance.BY')" :size="size" @handleQuery="handleQuery" @add="add"></enrollment>
    <!-- 车辆列表 -->
    <div class="page_container_a">
      <el-table :data="dataList" border :size="size" highlight-current-row>
        <el-table-column :label="$t('maintenance.order')" align="center" type="index" min-width="70"></el-table-column>
        <el-table-column :label="$t('maintenance.basicInfo')" align="center">
          <el-table-column :label="$t('vehicle.carNo')" align="center" prop="carNo" min-width="110"></el-table-column>
          <el-table-column :label="$t('maintenance.currentMileage')" align="center" prop="mileage" min-width="120"></el-table-column>
          <el-table-column :label="$t('maintenance.currentRunTime')" align="center" prop="runTime" min-width="130"></el-table-column>
        </el-table-column>
        <el-table-column :label="$t('maintenance.alertsByMileage')" align="center">
          <el-table-column :label="$t('maintenance.lastMilea')" align="center" prop="lastMileage"  min-width="140"></el-table-column>
          <el-table-column :label="$t('maintenance.nextBYMileage')" align="center" min-width="140">
            <template slot-scope="scope">{{scope.row.lastMileage ? scope.row.lastMileage + scope.row.intervalMileage : ""}}</template>
          </el-table-column>
        </el-table-column>
        <el-table-column :label="$t('maintenance.periodicReminders')" align="center">
          <el-table-column :label="$t('maintenance.lastMaintainTime')" align="center" prop="lastContainDate"  min-width="140"></el-table-column>
          <el-table-column :label="$t('maintenance.nextBYTime')" align="center" min-width="140">
            <template slot-scope="scope">{{containNextDate(scope.row.lastContainDate, scope.row.intervalMonths) }}</template>
          </el-table-column>
        </el-table-column>
<!--        <el-table-column :label="$t('maintenance.ByEngineRunTime')" align="center">
          <el-table-column :label="$t('maintenance.lastRun')" align="center" prop="lastHours"  min-width="170"></el-table-column>
          <el-table-column :label="$t('maintenance.nextBYRun')" align="center" min-width="170">
            <template slot-scope="scope">{{scope.row.lastHours ? scope.row.lastHours + scope.row.intervalHours : ""}}</template>
          </el-table-column>
        </el-table-column> -->
        <el-table-column :label="$t('public.Operation')" align="center" width="160" fixed="right">
          <template slot-scope="scope">
            <el-link
              :underline="false" 
              style="margin-right:10px" 
              @click="edit(scope.row)">
              <i class="iconfont icon-icon_operat_edite" style="height: 16px;width:16px"></i> {{$t("public.edit")}}
            </el-link>
            <el-link
              :underline="false" 
              @click="del(scope.row)"><i class="iconfont icon-icon_operat_delete" style="height: 16px;width:16px"></i> {{$t("public.del")}}
            </el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <kl-pagination
      :total="total"
      :currentPage="currentPage"
      @current-change="currentchange"
    ></kl-pagination>
    <!-- 弹窗 -->
    <el-dialog  class="dialog" :title="title" :visible.sync="dialogVisible" width="480px" :close-on-click-modal="false">
      <div  style="text-align:left;">
        <el-form ref="form" :model="form" :rules="rules1" :label-position="LanguageId == 1 ? 'right' : 'top'">
          <el-form-item :label="$t('maintenance.currentBY')" label-position="left" label-width="130px" filterable  prop="selCarNo">
            <el-select v-model="form.selCarNo" :size="size" style="width:250px" :disabled="BYFlag == 1" filterable clearable>
              <el-option v-for="item in vehiclesOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-checkbox :label="$t('maintenance.alertsByMileage')" v-model="checkedMilea" style="font-weight: bold;"></el-checkbox>
          </el-form-item>
          <el-form-item :label="$t('maintenance.lastMilea')" label-width="220px" prop="lastMilea"
              :rules="checkedMilea ? rulesUtils.checkNumber : []">
            <el-input v-model.number="form.lastMilea" :size="size" :style="{width:LanguageId == 1 ? '150px' : '250px'}" :disabled="!checkedMilea"></el-input><span> {{$t("runState.km")}}</span>
          </el-form-item>
          <el-form-item :label="$t('maintenance.intervalMilea')" label-width="220px" prop="intervalMilea"
              :rules="checkedMilea ? rulesUtils.checkNumber : []">
            <el-input v-model.number="form.intervalMilea" :size="size" :style="{width:LanguageId == 1 ? '150px' : '250px'}" :disabled="!checkedMilea"></el-input><span> {{$t("runState.km")}}</span>
          </el-form-item>
          <el-form-item :label="$t('maintenance.reminder')" label-width="220px" prop="reminderPeriodMilea"
              :rules="checkedMilea ? rulesUtils.checkNumber : []">
            <el-input v-model.number="form.reminderPeriodMilea" :size="size" :style="{width:LanguageId == 1 ? '150px' : '250px'}" :disabled="!checkedMilea"></el-input><span> {{$t("runState.km")}}</span>
          </el-form-item>

          <el-form-item >
            <el-checkbox :label="$t('maintenance.periodicReminders')" v-model="checkedCycle"  style="font-weight: bold;"></el-checkbox>
          </el-form-item>
          <el-form-item :label="$t('maintenance.lastTime')" label-width="220px" :prop="checkedCycle ? 'lastTime' : ''">
            <el-date-picker v-model="form.lastTime" placeholder="" :size="size"  :style="{width:LanguageId == 1 ? '150px' : '250px'}" :disabled="!checkedCycle"></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('maintenance.intervalTime')" label-width="220px" prop="intervalTime"
              :rules="checkedCycle ? rulesUtils.checkNumber : []">
            <el-input v-model.number="form.intervalTime" :size="size" :style="{width:LanguageId == 1 ? '150px' : '250px'}" :disabled="!checkedCycle"></el-input><span> {{$t("time.month")}}</span>
          </el-form-item>
          <el-form-item :label="$t('maintenance.reminder')" label-width="220px" prop="reminderPeriodTime"
              :rules="checkedCycle ? rulesUtils.checkNumber : []">
            <el-input v-model.number="form.reminderPeriodTime" :size="size" :style="{width:LanguageId == 1 ? '150px' : '250px'}" :disabled="!checkedCycle"></el-input><span> {{$t("maintenance.day")}}</span>
          </el-form-item>

          <!-- <el-form-item > -->
         <!--   <el-checkbox :label="$t('maintenance.ByEngineRunTime')" v-model="checkedRun"  style="font-weight: bold;"></el-checkbox>
          </el-form-item> -->
     <!--     <el-form-item :label="$t('maintenance.lastRun')" label-width="220px" prop="lastRun"
              :rules="checkedRun ? rulesUtils.checkNumber : []">
            <el-input v-model.number="form.lastRun" :size="size" :style="{width:LanguageId == 1 ? '150px' : '250px'}" :disabled="!checkedRun"></el-input><span> {{$t("time.hour")}}</span>
          </el-form-item> -->
       <!--   <el-form-item :label="$t('maintenance.intervalTime')" label-width="220px" prop="intervalRun"
              :rules="checkedRun ? rulesUtils.checkNumber : []">
            <el-input v-model.number="form.intervalRun" :size="size" :style="{width:LanguageId == 1 ? '150px' : '250px'}" :disabled="!checkedRun"></el-input><span> {{$t("time.hour")}}</span>
          </el-form-item> -->
      <!--    <el-form-item :label="$t('maintenance.reminder')" label-width="220px" prop="reminderPeriodRun"
              :rules="checkedRun ? rulesUtils.checkNumber : []">
            <el-input v-model.number="form.reminderPeriodRun" :size="size" :style="{width:LanguageId == 1 ? '150px' : '250px'}" :disabled="!checkedRun"></el-input><span> {{$t("maintenance.day")}}</span>
          </el-form-item> -->
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{$t("public.cancel")}}</el-button>
        <el-button type="primary" @click="submitSave">{{$t("public.save")}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import KLLabel from '@/components/KLLabel.vue'
import Enrollment from '../components/enrollment.vue'
import { mapState } from "vuex";
	import rules from '@/utils/rules'
import language from '@/utils/getLanguageId'
export default {
    name: "upkeeprecord",
  data(){
    return{
      rulesUtils: rules,
      rules1:{
        selCarNo: [
          { required: true, message: this.$t('maintenancemanagement.selectvehicle'), trigger: 'change' }
        ],
        lastTime: [
          { required: true, message: this.$t('vehicleInfo.selectusedate'), trigger: 'change' }
        ],
      },
      currentPage:1,
      total:0,
      isEdit:false,
      checkedCycle:false,
      checkedRun:false,
      checkedMilea:false,
      BYFlag:0,
      form:{
        lastRun:"",
        lastTime:"",
        lastMilea:"",
        intervalRun:"",
        intervalTime:"",
        intervalMilea:"",
        reminderPeriodRun:"",
        reminderPeriodTime:"",
        reminderPeriodMilea:"",
        selCarNo:"",
        lastMileageTemp:"",
        lastContainDateTemp:"",
        lastHoursTemp:""
      },
      dialogVisible:false,
      dataList:[],
      inputCarNo:"",
      tableSelected:[],
      vehiclesOption:[],
      VehicleID:undefined,
      lastMileageTemp:undefined,
      lastContainDateTemp:undefined,
      lastHoursTemp:undefined,
      LanguageId:1,
    }
  },
  props:{},
  components:{ Enrollment, KLLabel},
  computed:{
    size() {
      return this.$store.getters.size
    },
    title(){
      if(this.BYFlag == 1) return this.$t("maintenance.BYEdit");
      else return this.$t("maintenance.BY");
    },
    ...mapState({
      operator: (state) => state.user.operator,
      appVehicles: state => state.app.vehicles,
    }),
  },
  watch:{
  },
  methods:{
    currentchange(page){
      this.currentPage = page;
      this.getList();
    },
    getList(){
      this.$api.maintainInfo({
        vehicle: this.inputCarNo,
        OperatorID: this.operator.OperatorId,
        PageNo:this.currentPage,
        PageSize:10,
      })
      .then((res)=>{
        this.dataList = res.data;
        this.total = res.count;
      })
      .catch((e)=>{

      })
    },
    containNextDate(last,interval){
      let next = "";
       // 校验参数有效性：last为有效日期字符串，interval为有效数字（如7）
       if (last && interval && !isNaN(Number(interval))) {
         // 使用moment解析原始日期，添加指定月份后格式化
         next = this.moment(last).add(Number(interval), 'months').format("YYYY-MM-DD");
       }
       return next;
    },
    submitSave(){
      if(!this.checkedRun){
        this.form.lastRun = null;
        this.form.intervalRun = null;
        this.form.reminderPeriodRun = null;
      }
      if(!this.checkedCycle){
        this.form.lastTime = null;
        this.form.intervalTime = null;
        this.form.reminderPeriodTime = null;
      }
      if(!this.checkedMilea){
        this.form.lastMilea = null;
        this.form.intervalMilea = null;
        this.form.reminderPeriodMilea = null;
      }

      var FlagMileage;
      var FlagCycle;
      var FlagFDJ;
      if(this.BYFlag == 1){//修改
        FlagMileage = this.checkedMilea ? 1 : 2; //1修改，2删除清空
        FlagCycle = this.checkedCycle ? 1 : 2; //1修改，2删除清空
        FlagFDJ = this.checkedRun ? 1 : 2; //1修改，2删除清空
      }else if(this.BYFlag == 0){//新增
        FlagMileage = this.checkedMilea ? 1 : 0;//1有效新增，0无效不新增
        FlagCycle = this.checkedCycle ? 1 : 0;
        FlagFDJ = this.checkedRun ? 1 : 0;
      }
      
      var VID = "";
      VID = this.BYFlag == 1 ? this.VehicleID : this.form.selCarNo;
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if(!this.checkedRun && !this.checkedCycle && !this.checkedMilea){
            this.$message.info(this.$t("maintenance.请至少选择一项提醒方式"));
            return;
          }
          if(this.checkedCycle && (this.form.lastTime == null || this.form.lastTime == undefined || this.form.lastTime == "")){
            this.$message.info(this.$t("maintenance.请选择上一次保养时间"));
            return;
          }
          this.$api.maintainSave({
            BYFlag: this.BYFlag,
            VehicleID: VID,
            FlagMileage: FlagMileage,//this.BYFlag == 1 ? 1 : this.checkedMilea ? 1 : 0,
            FlagCycle: FlagCycle,//this.BYFlag == 1 ? 1 : this.checkedCycle ? 1 : 0,
            FlagFDJ: FlagFDJ,//this.BYFlag == 1 ? 1 : this.checkedRun ? 1 : 0,
            lastMileage: this.form.lastMilea ,//? this.form.lastMilea : "",
            intervalMileage: this.form.intervalMilea ,//? this.form.intervalMilea : "",
            remindMileage: this.form.reminderPeriodMilea ,//? this.form.reminderPeriodMilea : "",
            lastContainDate: this.form.lastTime ? this.moment(this.form.lastTime).format("YYYY-MM-DD") : null,//"",
            intervalMonths: this.form.intervalTime ,//? this.form.intervalTime : "",
            remindDays: this.form.reminderPeriodTime ,//? this.form.reminderPeriodTime : "",
            lastHours: this.form.lastRun ,//? this.form.lastRun : "",
            intervalHours: this.form.intervalRun ,//? this.form.intervalRun : "",
            remindHours: this.form.reminderPeriodRun ,//? this.form.reminderPeriodRun : "",
            lastMileageTemp: this.BYFlag == 1 ? this.lastMileageTemp == null ? "" : this.lastMileageTemp : "",
            lastContainDateTemp: this.BYFlag == 1 ? this.lastContainDateTemp == null ? "" : this.lastContainDateTemp : "",
            lastHoursTemp: this.BYFlag == 1 ? this.lastHoursTemp == null ? "" : this.lastHoursTemp : "",
          })
          .then((res)=>{
            if(res && res.code == 200){
              this.getList();
              this.dialogVisible = false;
              this.$message.success(this.$t("public.hasSaved"));
            }
          })
          .catch((e)=>{
            this.dialogVisible = false;
            let errorInfo = "";
            if(e.response.data.message === "查询到之前设置过里程保养记录") errorInfo = "，"+ this.$t("maintenance.RecordsAlreadyExist");
            this.$message.error(this.$t("public.SaveFail") + errorInfo);
          })
        } else {
        }
      });
      
    },
    handleQuery(val){
      // console.log(val);
      this.inputCarNo = val;
      this.currentPage = 1;
      this.getList();
    },
    add(){
      this.BYFlag = 0;
      this.dialogVisible = true;
      this.resetForm("form");
      
    },
    edit(row){
      this.BYFlag = 1;
      this.VehicleID = row.VehicleID;
      this.lastMileageTemp = row.lastMileage;
      this.lastContainDateTemp = row.lastContainDate;
      this.lastHoursTemp = row.lastHours;
      this.dialogVisible = true;
      this.resetForm("form");
      //三个提醒是仅一个还是可多个？   原代码可多个
      if(row.lastMileage) this.checkedMilea = true;
      if(row.lastContainDate) this.checkedCycle = true;
      if(row.lastHours) this.checkedRun = true;
      this.form = {
        lastRun:row.lastHours,
        intervalRun:row.intervalHours,
        reminderPeriodRun:row.remindHours,

        lastTime:row.lastContainDate,
        intervalTime:row.intervalMonths,
        reminderPeriodTime:row.remindDays,

        lastMilea:row.lastMileage,
        intervalMilea:row.intervalMileage,
        reminderPeriodMilea:row.remindMileage,
        selCarNo:row.carNo,
      }
    },
    del(row){
      this.$confirm(
        this.$t('maintenance.confirmDelete') + ' ' + row.carNo,
        "",
        {
          confirmButtonText: this.$t('public.confirm'),
          cancelButtonText: this.$t('public.cancel'),
          type: "warning",
        }
      )
      .then(() => {
        this.$api.maintainDel({
          VehicleID: row.VehicleID,
          lastMileage: row.lastMileage ? row.lastMileage : "",
          lastContainDate: row.lastContainDate ? row.lastContainDate : "",
          lastHours: row.lastHours ? row.lastHours : "",
        })
        .then((res) => {
          if (res && res.code == 200) {
            this.getList();
            this.$message.success(this.$t('public.hasDeleted'));
          } else {
            this.$message.warning(res.message);
          }
        })
        .catch((e)=>{

        })
      })
      .catch(() => {});
    },
    resetForm(refName) {
      this.checkedRun = false,
      this.checkedCycle = false,
      this.checkedMilea = false,
      this.form = {
        lastRun:"",
        intervalRun:"",
        reminderPeriodRun:"",
        lastTime:"",
        intervalTime:"",
        reminderPeriodTime:"",
        lastMilea:"",
        intervalMilea:"",
        reminderPeriodMilea:"",
        selCarNo:"",
        lastMileageTemp:"",
        lastContainDateTemp:"",
        lastHoursTemp:""
      }
      if (this.$refs[refName]) {
        this.$refs[refName].resetFields();
      }
    }
  },
  mounted(){
    this.LanguageId = language(this.$store.getters.locale)
    setTimeout(()=>{
      const appVeh = JSON.parse(JSON.stringify(this.appVehicles));
      appVeh.data.forEach(element => {
        if(element.treeLevel == 5){
          this.vehiclesOption.push({
            value: element.nodeValue,
            label: element.vehicleName,
          })
        }
      });
    },50);
    
    this.getList();
  },
}
</script>
<style lang="scss" scoped>
::v-deep [type="number"]::-webkit-inner-spin-button, [type="number"]::-webkit-outer-spin-button{
  display: none;
}
::v-deep .el-form-item__error{
  padding-top: 0px !important;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.dialog{
  ::v-deep .el-dialog__header {
    border-bottom: 1px solid #EBEEF5 !important;
  }
}
.page_container_a {
  margin-top: 10px;

  ::v-deep .el-table tr {
        background: rgb(244, 248, 255);
    }

  ::v-deep .el-table {
        background: rgb(244, 248, 255);
    }

    ::v-deep .el-table td {
        background: rgb(244, 248, 255);
    }
} 
</style>